/*
  OFFE - random % off stickers in the cart drawers' "You may also like"
  cards (Rachel, Oct 27, 2026). Same rules as the product page rows
  (offe-product-rails.js): random shape and colour, never the same shape
  or colour as the card before it, no shape + colour pair twice in a list.
  Styles: assets/offe-drawer-recs.css. Watches the drawers because the
  add-to-cart drawer loads its cards after opening.
*/
(function () {
  var SHAPES = {
    star: ['50.6cqw', '48.7cqw', '-11cqw', '-20.75cqw'],
    hex: ['51.3cqw', '44.8cqw', '-14.7cqw', '-13.2cqw'],
    clover: ['35.7cqw', '35.7cqw', '-8cqw', '-9.3cqw'],
    wavy: ['37cqw', '38.3cqw', '-7.6cqw', '-9.3cqw']
  };
  var NAMES = Object.keys(SHAPES);
  var COLORS = ['#a9defe', '#c1b3ff', '#629b26', '#7598e9', '#bebe41'];
  var LISTS = '.cart-drawer .cart-notification__recommend-list';
  var base = null;

  function shapeUrl(name) {
    if (!base) {
      var link = document.querySelector('link[href*="offe-drawer-recs.css"]');
      if (!link) return null;
      base = link.href.split('offe-drawer-recs.css')[0];
    }
    return 'url("' + base + 'offe-sale-' + name + '.svg")';
  }
  function pick(prevS, prevC, used) {
    var ok = [];
    NAMES.forEach(function (s) {
      if (s === prevS) return;
      COLORS.forEach(function (c) { if (c !== prevC && !used[s + c]) ok.push([s, c]); });
    });
    if (!ok.length) NAMES.forEach(function (s) { COLORS.forEach(function (c) { ok.push([s, c]); }); });
    return ok[Math.floor(Math.random() * ok.length)];
  }
  function paint() {
    document.querySelectorAll(LISTS).forEach(function (list) {
      var prevS = null, prevC = null, used = {};
      list.querySelectorAll('.cart-notification__recommend-item').forEach(function (item) {
        var badge = item.querySelector('.badge--sale');
        if (!badge) return;
        if (badge.hasAttribute('data-offe-stk')) {
          prevS = badge.getAttribute('data-offe-stk'); prevC = badge.getAttribute('data-offe-fill');
          used[prevS + prevC] = 1;
          return;
        }
        var p = pick(prevS, prevC, used);
        var url = shapeUrl(p[0]);
        if (!url) return;
        prevS = p[0]; prevC = p[1]; used[p[0] + p[1]] = 1;
        var d = SHAPES[p[0]];
        badge.style.setProperty('--sale-shape', url);
        badge.style.setProperty('--sale-fill', p[1]);
        badge.style.setProperty('width', d[0], 'important');
        badge.style.setProperty('height', d[1], 'important');
        badge.style.setProperty('left', d[2]);
        badge.style.setProperty('top', d[3]);
        badge.style.setProperty('transform-origin', d[2].replace('-', '') + ' ' + d[3].replace('-', ''));
        badge.setAttribute('data-offe-fill', p[1]);
        badge.setAttribute('data-offe-stk', p[0]);
      });
    });
  }
  function start() {
    paint();
    var t;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(paint, 60); });
    ['CartDrawer', 'CartNotification'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) mo.observe(el.parentElement || el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  OFFE - header bag count (Rachel, Oct 27): the theme writes "0" in the
  bag's count when the bag is empty, so mark the bag link empty and
  custom-nav-hover.css hides the little number then. Re-checks whenever the
  theme refreshes the bag after an add / remove.
*/
(function () {
  function check() {
    document.querySelectorAll('.header__cart > a').forEach(function (a) {
      var n = a.querySelector('.cart-count-bubble__count [aria-hidden]');
      var count = n ? parseInt(n.textContent, 10) || 0 : 0;
      a.classList.toggle('offe-bag-empty', count === 0);
    });
  }
  function start() {
    check();
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(check, 30); })
      .observe(document.querySelector('.shopify-section-header') || document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  OFFE - homepage spotlight cards on phones (Rachel, Oct 27): the random
  shape + colour per card (custom-figma-desktop.js part 6) didn't show on
  phones, for two reasons:
    1. the theme's spotlight-cards.js wipes each card's inline style when it
       switches the row to phone layout, which threw the picks away (the
       cards fell back to the "Tile hover shape" section's fixed picks);
    2. the coloured backdrop behind the shape was only turned on for
       desktop (custom-figma-desktop.css, 1160px+).
  This puts the picks back whenever they are wiped (same shape and colour
  the card already had) and turns the backdrop on below 1160px too.
*/
(function () {
  var css = document.createElement('style');
  css.textContent = '@media screen and (max-width: 1159.98px) { html[data-spot-morph]:not([data-spot-morph="off"]) .template-index .spotlight-cards__image-wrapper { background-color: var(--spot-morph-backdrop) !important; overflow: hidden !important; } }';
  document.head.appendChild(css);
  function restore() {
    document.querySelectorAll('.spotlight-cards__item[data-offe-shape]').forEach(function (c) {
      var shape = c.getAttribute('data-offe-shape'), color = c.getAttribute('data-offe-color');
      if (c.style.getPropertyValue('--spot-morph-backdrop') === color) return;
      c.style.setProperty('--spot-shape-rest', 'var(--shape-' + shape + '-rest)');
      c.style.setProperty('--spot-shape-hover', 'var(--shape-' + shape + '-hover)');
      c.style.setProperty('--spot-morph-backdrop', color);
    });
  }
  function start() {
    restore();
    document.querySelectorAll('.spotlight-cards-section').forEach(function (s) {
      new MutationObserver(restore).observe(s, { attributes: true, attributeFilter: ['style', 'data-offe-shape'], childList: true, subtree: true });
    });
    window.addEventListener('load', restore);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();

/*
  OFFE - signed-in account icon in the header (Rachel, Nov 2): once a shopper
  is logged in, Shopify's account button (<shopify-account>) swaps the
  person icon for a round avatar with their initial (lime circle). It lives
  inside the component's own shadow DOM, which the theme CSS can't reach, so
  this adds a small stylesheet into it: same wavy sticker shape as the search
  and bag icons (assets/offe-icon-sticker.svg, 34 x 35px), plum #520918
  with the customer's initial in cream like the other icons (Rachel, Nov 2;
  briefly lime #BDBE40), periwinkle with a rust initial on hover - desktop header (1160px+) only, like the other
  stickers in custom-figma-desktop.css.
*/
(function () {
  var sheet = null;
  function makeSheet() {
    if (sheet) return sheet;
    var link = document.querySelector('link[href*="offe-drawer-recs.css"]');
    if (!link || !window.CSSStyleSheet) return null;
    var url = link.href.split('offe-drawer-recs.css')[0] + 'offe-icon-sticker.svg';
    var mask = 'url("' + url + '") center / 34px 35px no-repeat';
    sheet = new CSSStyleSheet();
    sheet.replaceSync('@media screen and (min-width: 1160px) {' +
      '.account-button__avatar { width: 34px !important; height: 35px !important; border-radius: 0 !important; box-shadow: none !important; background: #520918 !important; color: #eff0eb !important; -webkit-mask: ' + mask + '; mask: ' + mask + '; scale: 1 !important; transform: none !important; animation: none !important; transition: background-color .2s, color .2s; }' +
      /* shoppers signed in with Shop get a 3D "coin" (purple Shop back side, ring, flip animation): flatten it to the front face */
      '.account-button__avatar::before, .account-button__avatar::after, .account-button__coin-front::before, .account-button__coin-front::after, .account-button__coin-back { display: none !important; }' +
      '.account-button__coin-front { position: absolute !important; inset: 0 !important; width: 100% !important; height: 100% !important; transform: none !important; background: transparent !important; color: inherit !important; border-radius: 0 !important; box-shadow: none !important; }' +
      '.account-button:hover .account-button__avatar { background: #7598e9 !important; color: #7e1e10 !important; }' +
      '.account-button__avatar-initials { font-family: "Denim INK", sans-serif !important; font-size: 15px !important; font-weight: 600 !important; color: inherit !important; text-box: none !important; }' +
      '.account-button__avatar-image { border-radius: 0 !important; }' +
    '}');
    return sheet;
  }
  function apply(el) {
    var sr = el.shadowRoot, s = makeSheet();
    if (!sr || !s || sr.adoptedStyleSheets.indexOf(s) !== -1) return;
    try { sr.adoptedStyleSheets = sr.adoptedStyleSheets.concat([s]); } catch (e) {}
  }
  function run() { document.querySelectorAll('shopify-account').forEach(apply); }
  function start() {
    run();
    if (window.customElements) customElements.whenDefined('shopify-account').then(function () {
      run();
      // the component can rebuild its styles when the shopper signs in/out
      document.querySelectorAll('shopify-account').forEach(function (el) {
        if (el.shadowRoot) new MutationObserver(function () { apply(el); }).observe(el.shadowRoot, { childList: true, subtree: true });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
